module.exports = __webpack_public_path__ + "img/categories.891534d3.png";